import { BlockModel } from './block.model';
import { CuratorBlockType } from './curator-block-type.model';
import { CuratorDisplayElement } from './curator-display-element.model';


export class CuratorBlock extends BlockModel {

    blocks: BlockModel[];
    originalBlocks: BlockModel[];
    type: CuratorBlockType;
    displayElement: CuratorDisplayElement;

    constructor(id?: number, type?: CuratorBlockType, displayElement?: CuratorDisplayElement, blocks?: BlockModel[], originalBlocks?: BlockModel[]) {
        super(id, type, displayElement);
        this.type = type;
        this.displayElement = displayElement || new CuratorDisplayElement();
        this.blocks = blocks || [];
        this.originalBlocks = originalBlocks || [];
        this.originalBlocks.forEach(block => block.displayElement.canAutomaticallyGenerated = true);
    }

    clone(): CuratorBlock {
        const clone = new CuratorBlock(
            this.id,
            (this.type as CuratorBlockType).clone(),
            this.displayElement.clone(),
            this.blocks.map(block => block.clone()),
            this.originalBlocks.map(item => item.clone())
        );
        // for some reason this.type.clone calls the parent blockType clone
        // so need to manually clone the method here
        clone.type.disableDropCondition = this.type.disableDropCondition;

        return clone;
    }
};
